/* ==========================================================================
   TrendyBits · Personalisation fields + product image lightbox
   Reads its configuration from <script id="tbpz-config" type="application/json">
   rendered by sections/tb-personalise.liquid.

   Two independent features, each guarded so a failure in one cannot break
   the other, and neither can break the existing tb-pdp section:
     1. relocate() — moves the required custom-text card into the real
        add-to-cart form and gates the submit button until it is filled.
     2. lightbox() — full screen image viewer over the existing gallery.
   ========================================================================== */
(function () {
  'use strict';

  var cfgEl = document.getElementById('tbpz-config');
  if (!cfgEl) return;

  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!CFG) return;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  /* ======================================================================
     1. PERSONALISATION
     ====================================================================== */
  function personalise() {
    if (!CFG.enabled) return;

    var card = document.querySelector('[data-tbpz-card]');
    var form = document.getElementById('tb-pdp-form');
    if (!card || !form) return;

    /* Never let the theme's own built-in field submit a duplicate property. */
    var legacy = document.querySelector('.tb-pdp__personalize');
    if (legacy) {
      var legacyIn = legacy.querySelector('input');
      if (legacyIn) { legacyIn.removeAttribute('name'); legacyIn.disabled = true; }
      legacy.style.display = 'none';
    }

    /* Move the card into the form, just above the buy button. */
    var buy = form.querySelector('.tb-pdp__buy');
    if (buy && buy.parentNode) {
      buy.parentNode.insertBefore(card, buy);
    } else {
      form.appendChild(card);
    }

    var host = document.querySelector('[data-tbpz]');
    if (host) host.removeAttribute('hidden');

    var fields = Array.prototype.slice.call(card.querySelectorAll('[data-tbpz-field]'));
    if (!fields.length) return;

    var submit = form.querySelector('[data-pdp-submit]');
    var note = card.parentNode.querySelector('[data-tbpz-note]');

    /* A note under the button explaining why it is locked. */
    if (!note && buy && buy.parentNode) {
      note = document.createElement('p');
      note.className = 'tbpz__note';
      note.setAttribute('data-tbpz-note', '');
      buy.parentNode.insertBefore(note, buy.nextSibling);
    }

    var previewParts = card.querySelectorAll('[data-tbpz-preview]');

    function stateOf(input) {
      return input.value.replace(/\s+/g, ' ').trim();
    }

    function paint() {
      var allFilled = true;

      fields.forEach(function (f) {
        var input = f.querySelector('.tbpz__in');
        var counter = f.querySelector('.tbpz__ct');
        if (!input) return;

        var val = stateOf(input);
        var max = parseInt(input.getAttribute('maxlength'), 10) || 20;

        if (counter) counter.textContent = input.value.length + ' / ' + max;

        if (val.length === 0) {
          allFilled = false;
          f.classList.remove('is-good');
          /* only show the red error once they have actually touched it */
          if (!f.hasAttribute('data-touched')) f.classList.remove('is-bad');
        } else {
          f.classList.remove('is-bad');
          f.classList.add('is-good');
        }
      });

      /* live preview line */
      Array.prototype.forEach.call(previewParts, function (b) {
        var idx = parseInt(b.getAttribute('data-tbpz-preview'), 10) || 0;
        var input = fields[idx] ? fields[idx].querySelector('.tbpz__in') : null;
        if (!input) return;
        var v = stateOf(input);
        b.textContent = v ? v.toUpperCase() : (CFG.previewEmpty || '—');
      });

      card.classList.toggle('is-good', allFilled);
      if (allFilled) card.classList.remove('is-bad');

      if (submit && !submit.hasAttribute('data-sold-out')) {
        submit.classList.toggle('tbpz-locked', !allFilled);
        submit.setAttribute('aria-disabled', allFilled ? 'false' : 'true');
      }
      if (note) {
        note.textContent = allFilled
          ? (CFG.readyText || '')
          : (CFG.lockText || 'Fill the field above to unlock this button');
        note.style.display = allFilled ? 'none' : '';
      }

      return allFilled;
    }

    function flagEmpty() {
      var first = null;
      fields.forEach(function (f) {
        var input = f.querySelector('.tbpz__in');
        if (!input) return;
        if (stateOf(input).length === 0) {
          f.setAttribute('data-touched', '');
          f.classList.add('is-bad');
          if (!first) first = input;
        }
      });
      card.classList.add('is-bad');
      if (first) {
        first.focus();
        if (card.scrollIntoView) card.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    fields.forEach(function (f) {
      var input = f.querySelector('.tbpz__in');
      if (!input) return;
      input.addEventListener('input', paint);
      input.addEventListener('blur', function () {
        f.setAttribute('data-touched', '');
        paint();
        if (stateOf(input).length === 0) f.classList.add('is-bad');
      });
    });

    /* Block the submit itself — this catches the Enter key too. */
    form.addEventListener('submit', function (ev) {
      if (!paint()) {
        ev.preventDefault();
        ev.stopPropagation();
        flagEmpty();
      }
    }, true);

    /* Clicking the greyed-out button explains itself instead of doing nothing. */
    if (submit) {
      submit.addEventListener('click', function (ev) {
        if (!paint()) {
          ev.preventDefault();
          ev.stopPropagation();
          flagEmpty();
        }
      }, true);
    }

    paint();
  }

  /* ======================================================================
     2. LIGHTBOX
     ====================================================================== */
  function lightbox() {
    var media = (CFG.media || []).filter(function (m) { return m && m.url; });
    if (!media.length) return;

    var slider = document.querySelector('.tb-pdp__main-slider');
    var slides = document.querySelectorAll('[data-slide-index]');
    var thumbs = document.querySelectorAll('[data-thumb-index]');
    if (!slider) return;

    /* --- the "tap to enlarge" chip --------------------------------------- */
    var chip = document.createElement('button');
    chip.type = 'button';
    chip.className = 'tbpz__zoom';
    chip.setAttribute('aria-label', CFG.zoomText || 'Tap to enlarge');
    chip.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle>' +
      '<path d="M20 20l-3.2-3.2M11 8.5v5M8.5 11h5"></path></svg><span></span>';
    chip.querySelector('span').textContent = CFG.zoomText || 'Tap to enlarge';
    slider.appendChild(chip);

    /* --- build the overlay once ------------------------------------------ */
    var lb = document.createElement('div');
    lb.className = 'tbpz-lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Product photos');
    lb.innerHTML = [
      '<div class="tbpz-lb__bar">',
      '  <span class="tbpz-lb__ct" data-lb-count></span>',
      '  <div class="tbpz-lb__tools">',
      '    <button type="button" class="tbpz-lb__ib" data-lb-out aria-label="Zoom out">',
      '      <svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"></circle><path d="M20 20l-3.2-3.2M8.5 11h5"></path></svg>',
      '    </button>',
      '    <button type="button" class="tbpz-lb__ib" data-lb-in aria-label="Zoom in">',
      '      <svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"></circle><path d="M20 20l-3.2-3.2M11 8.5v5M8.5 11h5"></path></svg>',
      '    </button>',
      '    <button type="button" class="tbpz-lb__ib" data-lb-close aria-label="Close">',
      '      <svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"></path></svg>',
      '    </button>',
      '  </div>',
      '</div>',
      '<div class="tbpz-lb__stage" data-lb-stage>',
      '  <img class="tbpz-lb__img" data-lb-img alt="">',
      '  <button type="button" class="tbpz-lb__nav prev" data-lb-prev aria-label="Previous photo">',
      '    <svg viewBox="0 0 24 24"><path d="M15 5l-7 7 7 7"></path></svg>',
      '  </button>',
      '  <button type="button" class="tbpz-lb__nav next" data-lb-next aria-label="Next photo">',
      '    <svg viewBox="0 0 24 24"><path d="M9 5l7 7-7 7"></path></svg>',
      '  </button>',
      '</div>',
      '<div class="tbpz-lb__strip" data-lb-strip></div>',
      '<div class="tbpz-lb__hint" data-lb-hint></div>'
    ].join('');
    document.body.appendChild(lb);

    var elImg = lb.querySelector('[data-lb-img]');
    var elStage = lb.querySelector('[data-lb-stage]');
    var elCount = lb.querySelector('[data-lb-count]');
    var elStrip = lb.querySelector('[data-lb-strip]');
    var elHint = lb.querySelector('[data-lb-hint]');
    var btnPrev = lb.querySelector('[data-lb-prev]');
    var btnNext = lb.querySelector('[data-lb-next]');

    elHint.innerHTML = '<b>' + (CFG.hintLead || 'Swipe') + '</b> ' +
      (CFG.hintRest || 'or use the arrows to browse · scroll or pinch to zoom · Esc to close');

    if (media.length < 2) {
      btnPrev.style.display = 'none';
      btnNext.style.display = 'none';
      elStrip.style.display = 'none';
    }

    /* thumbnail strip inside the lightbox — shows ALL media, not just five */
    media.forEach(function (m, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Photo ' + (i + 1));
      var im = document.createElement('img');
      im.src = m.thumb || m.url;
      im.alt = '';
      im.loading = 'lazy';
      b.appendChild(im);
      b.addEventListener('click', function () { show(i); });
      elStrip.appendChild(b);
    });
    var stripBtns = elStrip.querySelectorAll('button');

    var idx = 0, zoom = 1, panX = 0, panY = 0, lastFocus = null;

    function applyTransform() {
      elImg.style.transform =
        'translate(' + panX + 'px,' + panY + 'px) scale(' + zoom + ')';
      elStage.classList.toggle('is-zoomed', zoom > 1.01);
    }

    function setZoom(z) {
      zoom = Math.min(4, Math.max(1, z));
      if (zoom === 1) { panX = 0; panY = 0; }
      applyTransform();
    }

    function show(i) {
      if (!media.length) return;
      idx = (i + media.length) % media.length;
      var m = media[idx];
      elImg.src = m.url;
      elImg.alt = m.alt || '';
      elCount.textContent = (idx + 1) + ' / ' + media.length;
      Array.prototype.forEach.call(stripBtns, function (b, n) {
        b.classList.toggle('is-on', n === idx);
      });
      setZoom(1);
      syncPage(idx);
    }

    /* keep the on-page gallery in step with the lightbox */
    function syncPage(i) {
      if (!slides.length) return;
      Array.prototype.forEach.call(slides, function (s) { s.classList.remove('active'); });
      Array.prototype.forEach.call(thumbs, function (t) { t.classList.remove('active'); });
      var s = document.querySelector('[data-slide-index="' + i + '"]');
      if (s) s.classList.add('active');
      var t = document.querySelector('[data-thumb-index="' + i + '"]');
      if (t) t.classList.add('active');
    }

    function currentPageIndex() {
      var active = document.querySelector('[data-slide-index].active');
      if (!active) return 0;
      var n = parseInt(active.getAttribute('data-slide-index'), 10);
      return isNaN(n) ? 0 : n;
    }

    function open(i) {
      lastFocus = document.activeElement;
      show(typeof i === 'number' ? i : currentPageIndex());
      lb.classList.add('is-open');
      document.body.classList.add('tbpz-lock');
      var closeBtn = lb.querySelector('[data-lb-close]');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      lb.classList.remove('is-open');
      document.body.classList.remove('tbpz-lock');
      setZoom(1);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    /* --- open triggers ---------------------------------------------------- */
    chip.addEventListener('click', function (e) { e.preventDefault(); open(); });
    Array.prototype.forEach.call(slides, function (s) {
      s.addEventListener('click', function () {
        var n = parseInt(s.getAttribute('data-slide-index'), 10);
        open(isNaN(n) ? 0 : n);
      });
    });

    /* --- controls --------------------------------------------------------- */
    btnPrev.addEventListener('click', function (e) { e.stopPropagation(); show(idx - 1); });
    btnNext.addEventListener('click', function (e) { e.stopPropagation(); show(idx + 1); });
    lb.querySelector('[data-lb-close]').addEventListener('click', close);
    lb.querySelector('[data-lb-in]').addEventListener('click', function () { setZoom(zoom + .5); });
    lb.querySelector('[data-lb-out]').addEventListener('click', function () { setZoom(zoom - .5); });

    /* a click that landed on one of the overlay's own buttons is never a
       backdrop click. Pointer capture (below) can retarget the click event to
       the stage, so test the real hit target too. */
    function isControl(t) {
      return !!(t && t.closest && t.closest('button'));
    }

    /* click the empty backdrop to close, but never while zoomed in */
    elStage.addEventListener('click', function (e) {
      if (lastHitControl) { lastHitControl = false; return; }
      if (e.target === elStage && zoom <= 1.01) close();
    });

    elImg.addEventListener('dblclick', function (e) {
      e.preventDefault();
      setZoom(zoom > 1.01 ? 1 : 2.2);
    });

    elStage.addEventListener('wheel', function (e) {
      if (!lb.classList.contains('is-open')) return;
      e.preventDefault();
      setZoom(zoom + (e.deltaY < 0 ? .28 : -.28));
    }, { passive: false });

    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); show(idx + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); show(idx - 1); }
      else if (e.key === '+' || e.key === '=') { setZoom(zoom + .5); }
      else if (e.key === '-') { setZoom(zoom - .5); }
    });

    /* --- pointer: pan when zoomed, swipe when not ------------------------- */
    var down = false, sx = 0, sy = 0, ox = 0, oy = 0, moved = false, lastHitControl = false;

    elStage.addEventListener('pointerdown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      /* Never capture the pointer for the arrows. Capturing retargets the
         following click to the stage, which swallowed the arrow click and
         closed the lightbox instead of changing photo. */
      if (isControl(e.target)) { lastHitControl = true; down = false; return; }
      lastHitControl = false;
      down = true; moved = false;
      sx = e.clientX; sy = e.clientY; ox = panX; oy = panY;
      elStage.classList.add('is-drag');
      if (elStage.setPointerCapture) { try { elStage.setPointerCapture(e.pointerId); } catch (err) {} }
    });

    elStage.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (Math.abs(dx) > 4 || Math.abs(dy) > 4) moved = true;
      if (zoom > 1.01) {
        panX = ox + dx; panY = oy + dy;
        applyTransform();
      }
    });

    function endDrag(e) {
      if (!down) return;
      down = false;
      elStage.classList.remove('is-drag');
      if (zoom <= 1.01 && moved && media.length > 1) {
        var dx = e.clientX - sx;
        if (dx < -55) show(idx + 1);
        else if (dx > 55) show(idx - 1);
      }
    }
    elStage.addEventListener('pointerup', endDrag);
    elStage.addEventListener('pointercancel', function () { down = false; elStage.classList.remove('is-drag'); });
  }

  /* ====================================================================== */
  ready(function () {
    try { personalise(); } catch (e) { if (window.console) console.warn('[tbpz] fields', e); }
    try { lightbox(); } catch (e) { if (window.console) console.warn('[tbpz] lightbox', e); }
  });
})();
